import { createPinia } from 'pinia';
import {} from 'vue';
export function registerPiniaStore(app) {
    const pinia = createPinia();
    app.use(pinia);
}
